export const ar = {
  Globals: {
    dashboard: "لوحة القيادة",
  },
};
